export default function Hero() {
  return (
    <section className="relative pt-0 pb-0 min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/fe3fb8aa9f279019f1abe769491c535f.jpg"
          alt="Video Editing Studio"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-32">
        <div className="max-w-2xl">
          <span className="inline-block px-4 py-1.5 bg-[#1E3A8A]/80 text-white text-xs font-semibold rounded-full mb-6 tracking-widest uppercase">
            Short-Form Video Editing
          </span>
          <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            We Edit Your Content.<br />
            <span className="text-[#60A5FA]">You Go Viral.</span>
          </h1>
          <p className="text-lg text-gray-300 mb-8 leading-relaxed">
            Send us your raw footage via Google Drive or Dropbox — we handle the cuts, music, captions, voiceovers, and everything in between. Professional short-form edits delivered fast.
          </p>

          <div className="flex flex-wrap gap-4 mb-10">
            <a
              href="#contact"
              className="px-8 py-3.5 bg-[#1E3A8A] text-white font-medium rounded-full hover:bg-[#1E3A8A]/90 transition-colors whitespace-nowrap cursor-pointer"
            >
              Submit Your Footage
            </a>
            <a
              href="#services"
              className="px-8 py-3.5 border-2 border-white text-white font-medium rounded-full hover:bg-white hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              See What We Do
            </a>
          </div>

          <div className="flex flex-wrap gap-8">
            {[
              { value: '48hr', label: 'Avg. Turnaround' },
              { value: '500+', label: 'Videos Edited' },
              { value: '100%', label: 'Satisfaction Rate' },
            ].map((stat) => (
              <div key={stat.label}>
                <p className="text-3xl font-bold text-white">{stat.value}</p>
                <p className="text-sm text-gray-400">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
